import React from 'react'

import useEmailEditorStore from '../../utilities/emailEditorStore';
import { Box, TextField, Typography,ButtonGroup,Button,Grid,Slider,} from '@mui/material';
import BlockProps from './common/BlockProps';
import { SpaceBar , VerticalAlignBottom,VerticalAlignCenter,VerticalAlignTop } from '@mui/icons-material';
function ColumnContainerBlockProperties({blockId}) {
const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };

  return (
   <>
    <Box sx={{mb:2}}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Columns
            </Typography>
            <ButtonGroup variant="outlined" sx={{width:'100%'}}>
               {[2, 3, 4, 5].map((num) => (
                    <Button
                        key={num}
                        onClick={() => handlePropertyChange('columnnumbers', num)}
                        variant={properties.columnnumbers === num ? 'contained' : 'outlined'}
                        sx={{ flex: 1 }} // 👈 Ensures each button takes equal width
                    >
                        {num}
                    </Button>
                    ))}
              
            </ButtonGroup>
    </Box>

   <Box>
            <Typography variant="body2" gutterBottom>
              Gap
            </Typography>
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid>
                <SpaceBar/>
              </Grid>
              <Grid size="grow">
                <Slider
                  value={properties.columngap || '5px'}
                  onChange={(e, value) => handlePropertyChange('columngap', value)}
                  aria-labelledby="input-slider-columngab"
                  step={1}
                  marks
                  max={100}
                  min={0}
                />
              </Grid>
              <Grid>
                <Typography variant="body2" gutterBottom>
                  {properties.columngap} px
                </Typography>
              </Grid>
            </Grid>
          </Box>
            <Box sx={{mb:2}}>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                        Align Items
                        </Typography>
                        <ButtonGroup variant="outlined" sx={{width:'100%'}}>
                            <Button
                                onClick={() => handlePropertyChange('alignItems', 'start')}
                                variant={properties.alignItems === 'start' ? 'contained' : 'outlined'}
                                sx={{ flex: 1 }}
                            >
                                <VerticalAlignTop/>
                            </Button>
                            <Button
                                onClick={() => handlePropertyChange('alignItems', 'center')}
                                variant={properties.alignItems === 'center' ? 'contained' : 'outlined'}
                                sx={{ flex: 1 }}
                            >
                                <VerticalAlignCenter/>
                            </Button>
                            <Button
                                onClick={() => handlePropertyChange('alignItems', 'end')}
                                variant={properties.alignItems === 'end' ? 'contained' : 'outlined'}
                                sx={{ flex: 1 }}
                            >
                                <VerticalAlignBottom/>
                            </Button>
                       
                        </ButtonGroup>
                </Box>
        
    <BlockProps properties={properties} onPropertyChange={handlePropertyChange} />
   </>
  )
}

export default ColumnContainerBlockProperties